<template>
  <svg width="24" height="24" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.52647 7.22978L11.1284 2.8363C11.4362 2.31659 11.9814 2 12.5687 2C13.6052 2 14.3978 2.96001 14.2402 4.02451L13.9567 5.93939C13.65 8.01075 15.1923 9.87879 17.2092 9.87879H18.0138C20.9733 9.87879 22.8981 13.115 21.5746 15.8655L20.2348 18.6498C19.2468 20.703 17.2272 22 15.018 22H11.6237C10.0514 22 8.66069 21.1919 7.81533 19.9536C7.82672 19.8292 7.83254 19.7032 7.83254 19.5758V9.87879C7.83254 9.47757 7.77482 9.09037 7.66753 8.72565C7.87427 8.33106 8.14952 7.86628 8.52647 7.22978Z"
      
    />
    <path
      d="M6.08278 19.5758C6.08278 20.7473 5.16882 21.697 4.04139 21.697C2.91396 21.697 2 20.7473 2 19.5758V9.87879C2 8.70727 2.91396 7.75758 4.04139 7.75758C5.16882 7.75758 6.08278 8.70727 6.08278 9.87879V19.5758Z"
      
    />
  </svg>
</template>
